import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a Balancing icon
 * (RDT value for Weekly reduced rest periods,
 * used in the Drivers module).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BalancingIcon width={12} />
 */
const BalancingIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M45.42,28.45v.25A21.71,21.71,0,0,1,10.84,41.05a21.68,21.68,0,0,1-4.3-29.61A21.64,
            21.64,0,0,1,36.72,6.35a21.15,21.15,0,0,1,2,1.55l1.87-1.35a1.05,1.05,0,0,1,1-.1,1.06,
            1.06,0,0,1,.64.81l.82,9.63a1,1,0,0,1-.16.66,1,1,0,0,1-1.39.28l-8-4.71a1.08,1.08,0,0,
            1-.46-.87,1.06,1.06,0,0,1,.44-.85l1.34-.94a5.08,5.08,0,0,0-.51-.41A17.21,17.21,0,0,
            0,13.6,37.51a17.35,17.35,0,0,0,24.23-2.88,17.05,17.05,0,0,0,3.24-6.75,2.77,2.77,0,0,
            1,.12-.41l.26.06.24.06,3.31.75.2.06Zm-29-15.17A13.1,13.1,0,1,0,36.71,28,13,13,0,0,1,
            20,11.29,13.24,13.24,0,0,0,16.37,13.28Z`}
        />
    </SvgIcon>
)

BalancingIcon.defaultProps = defaultProps

export { BalancingIcon }
